import React from "react";

import { IMedicalFormItemProps } from "../../Types/IMedicalFormItemProps";

export interface IDisablerMedicalFormItemDecoratorConfig {
  /** The predicate function to determine if the form item should be disabled.
   * @param formState The current state of the form.
   */
  isDisabled: (formState: IMedicalFormItemProps["formState"]) => boolean;
  /** The form item to decorate with disabler functionality. */
  FormItem: React.FC<IMedicalFormItemProps>;
}

const DisablerMedicalFormItemDecorator: React.FC<IMedicalFormItemProps & IDisablerMedicalFormItemDecoratorConfig> = ({
  formState,
  isDisabled,
  FormItem,
  ...rest
}) => {
  return <FormItem {...rest} formState={formState} disabled={isDisabled(formState)} />;
};

export default DisablerMedicalFormItemDecorator;
